var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"birthdate-input",class:{ 'birthdate-input--corrected': _vm.corrected },on:{"focusin":_vm.dismiss_correction,"input":function($event){_vm.user_edited = true},"change":function($event){_vm.user_edited = true}}},[_c('label',{staticClass:"sr-only",attrs:{"for":_vm.input_ids.day}},[_vm._v("Giorno")]),_c('vb-input',{attrs:{"vb_options":{
      id: _vm.input_ids.day,
      autocomplete: 'bday-day',
      max: _vm.days_in_selected_month,
      min: 1,
      number: true,
      placeholder: 'Giorno',
      type: 'number',
      value: _vm.birth_day,
    }},model:{value:(_vm.birth_day),callback:function ($$v) {_vm.birth_day=$$v},expression:"birth_day"}}),_c('label',{staticClass:"sr-only",attrs:{"for":_vm.input_ids.month}},[_vm._v("Mese")]),_c('vb-select',{staticClass:"birthdate-input__month",class:{ 'birthdate-input__month--placeholder': !_vm.month_is_selected },attrs:{"vb_options":{
      id: _vm.input_ids.month,
      options: _vm.month_options,
      text_field: 'label',
      value: _vm.birth_month,
      value_field: 'index',
    }},model:{value:(_vm.birth_month),callback:function ($$v) {_vm.birth_month=$$v},expression:"birth_month"}}),_c('label',{staticClass:"sr-only",attrs:{"for":_vm.input_ids.year}},[_vm._v("Anno")]),_c('vb-input',{attrs:{"vb_options":{
      id: _vm.input_ids.year,
      autocomplete: 'bday-year',
      max: _vm.selectable_years.max,
      min: _vm.selectable_years.min,
      number: true,
      placeholder: 'Anno',
      type: 'number',
      value: _vm.birth_year,
    }},model:{value:(_vm.birth_year),callback:function ($$v) {_vm.birth_year=$$v},expression:"birth_year"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }